import React, { FC } from 'react'
import styles from './List.module.scss'
import classnames from 'classnames'
import { ListItemProps, ListProps, ListHeaderProps } from './types'
import Icon from '../Icon'
import getColorClass from '@bt-react/libs/getColorClass'
import { colour } from '../Icon/types'

export const ListHeader: FC<ListHeaderProps> = ({ dataBdd = 'list-header', icon, title }) => {

  const headerClasses = classnames(
    styles['list-header'],
    styles['list-item--large'],
    styles['list-item--separated']
  )

  return <div className={headerClasses} data-bdd={dataBdd} >
    { icon && <div className={styles['list-header-icon-container']}><Icon name={icon} className={styles['list-header-icon']} /></div> }
    {
      typeof title === 'string'
        ? <div className={styles['list-header-title']}>{ title }</div>
        : title
    }
  </div>

}

export const ListItem: FC<ListItemProps> = ({ content, dataBdd = 'list-item', size, separated, color = colour.white, children, className, onClick, onMouseDown, href, rel, target, tabIndex = 0 }) => {

  const listClasses = classnames(styles['list-item'], {
      [styles['list-item--medium']]: size === 'medium' || !size,
      [styles['list-item--large']]: size === 'large',
      [styles['list-item--separated']]: separated
    },
    getColorClass(color, 'backgroundColor'),
    className
  )

  if (href) {

    return <a
      href={href}
      className={classnames(styles['list-item-button'], listClasses)}
      data-bdd={dataBdd}
      rel={rel}
      target={target}
      onClick={onClick}
      tabIndex={tabIndex}
    >
      { content || children }
    </a>

  }

  return onClick || onMouseDown
    ? <button
        className={classnames(styles['list-item-button'], listClasses)}
        data-bdd={dataBdd}
        onClick={onClick}
        onMouseDown={onMouseDown}
        tabIndex={tabIndex}
      >
        { content || children }
      </button>
    : <div
        className={listClasses}
        data-bdd={dataBdd}
        tabIndex={tabIndex}
      >
        { content || children }
      </div>

}

const List: FC<ListProps> = ({ dataBdd = 'list', separated = false, header, content = [], color = colour.white, size, children, className }) => {

  return <div data-bdd={dataBdd} className={classnames(styles['list'], className)} >
    {
      header &&
      <ListHeader { ...header } />
    }
    {
      content.map((content, i) =>
        <ListItem
          dataBdd={`${dataBdd}-${i}`}
          content={content}
          size={size}
          key={`${dataBdd}-${i}`}
          separated={separated}
          color={color}
        />)
    }
    {
      content.length === 0 && children
    }
  </div>

}

export default List
